


















import { Component, Prop, Vue, Provide, Watch } from 'vue-property-decorator';

@Component({

})
export default class SelectPerson extends Vue {
  @Prop() private airport: any;
  private $api: any;
  private name: string =  '';
  private userlist: any[] = [];
  @Prop() private user: any;
  private determined: boolean = false; 

  @Watch('name')
  private onType(val: string) {
    // console.log(val);
    if (this.determined) {
      this.determined = false;
      return;
    }
    this.getUser(val);
  }

  @Watch('user.UserName')
  private onUserChange() {
    this.determined = true;
    this.name = this.user.UserName;
  }

  private mounted() {
    if (this.user.UserName) {
      this.determined = true;
      this.name = this.user.UserName;
    }
  }

  // 查询
  private async getUser(name: string) {
    const params: any = {
      UserName: name,
    };
    const result = await this.$api.httpPost('Membership/UserBaseInfo/ListByNameState', params);
    if (result.Success && result.Data) {
      this.userlist = result.Data;
    }
  }
  
  // 被选择
  private onSelect(user: any) {
    this.determined = this.name !== user.UserName;
    this.name = user.UserName;
    this.userlist = [];
    this.$emit('input', user);
  }
  
  // 失去焦点
  private onBlur() {
    setTimeout(() => {
      this.userlist = [];
    }, 0);
     
  }
  
}
